import { ICommonQuery } from '@Models/common.model'
import { MReportUser } from '@Models/Report/users.model'
import { APIServices } from '@Services/api.service'
import { ToastServices } from '@Services/toast.service'
import { ReportActionTypes } from '@Stores/report/report.action-types'
import SharedActions from '@Stores/shared/actions/loading.action'
import axios, { AxiosError, AxiosResponse } from 'axios'
import moment from 'moment'
import * as Redux from 'redux'

const users = `${APIServices.apiUrlV1}/admin/users`

const getUserDetail = (id: string) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setPageLoading(true) as any)
        const url = `${APIServices.apiUrlV1}/admin/users/${id}`
        APIServices.axiosConfig()
        axios
            .get(`${url}`)
            .then((res) => {
                dispatch(SharedActions.setPageLoading(false) as any)
                dispatch({
                    type: ReportActionTypes.GET_USER_DETAIL,
                    payload: res.data,
                })
            })
            .catch((errors) => {
                dispatch(SharedActions.setPageLoading(false) as any)
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const getFirearms = (id: string) => {
    return (dispatch: Redux.Dispatch) => {
        const params = {
            limit: 0,
        }
        const url = `${APIServices.apiUrlV1}/admin/users/${id}/firearms`
        // APIServices.axiosConfig()
        axios
            .get(`${url}`, { params })
            .then((res) => {
                const data = res.data?.data?.map((item: any) => ({
                    id: item?.code,
                    image: item?.imageUrl,
                    serialNumber: item?.serialCode,
                    ffl: item?.fflId,
                    make: item?.make?.name,
                    model: item?.model?.name,
                    caliber: item?.caliber,
                    platform: item?.safeType?.name,
                    type: item?.safeSubType?.name,
                }))
                dispatch({
                    type: ReportActionTypes.GET_USER_FIREARMS,
                    payload: data,
                })
            })
            .catch((errors) => {
                // dispatch({
                //     type: EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL,
                //     payload: false,
                // })
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const getInsurances = (id: string) => {
    return (dispatch: Redux.Dispatch) => {
        const params = {
            limit: 0,
        }
        const url = `${APIServices.apiUrlV1}/admin/users/${id}/insurances`
        // APIServices.axiosConfig()
        axios
            .get(`${url}`, { params })
            .then((res) => {
                const data = res.data?.data?.map((item: any) => ({
                    id: item?.code,
                    startDate: moment(item?.startDate).format('DD/MM/YYYY'),
                    endDate: moment(item?.endDate).format('DD/MM/YYYY'),
                    phone: item?.phone,
                    address: item?.address,
                    city: item?.city?.name,
                    state: item?.state?.name,
                    zipCode: item?.zip,
                    policy: item?.policy,
                }))
                dispatch({
                    type: ReportActionTypes.GET_USER_INSURANCES,
                    payload: data,
                })
            })
            .catch((errors) => {
                // dispatch({
                //     type: EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL,
                //     payload: false,
                // })
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const getInspections = (id: string) => {
    return (dispatch: Redux.Dispatch) => {
        const params = {
            limit: 0,
        }
        const url = `${APIServices.apiUrlV1}/admin/users/${id}/inspections`
        // APIServices.axiosConfig()
        axios
            .get(`${url}`, { params })
            .then((res) => {
                const data = res.data?.data?.map((item: any) => ({
                    id: item?.code,
                    startDate: item?.startedDate
                        ? moment(item?.startedDate).format('DD/MM/YYYY')
                        : '',
                    endDate: item?.expiredDate
                        ? moment(item?.expiredDate).format('DD/MM/YYYY')
                        : '',
                }))
                dispatch({
                    type: ReportActionTypes.GET_USER_INSPECTIONS,
                    payload: data,
                })
            })
            .catch((errors) => {
                // dispatch({
                //     type: EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL,
                //     payload: false,
                // })
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const getSafeStorages = (id: string) => {
    return (dispatch: Redux.Dispatch) => {
        const params = {
            limit: 0,
        }
        const url = `${APIServices.apiUrlV1}/admin/users/${id}/safe-storages`
        // APIServices.axiosConfig()
        axios
            .get(`${url}`, { params })
            .then((res) => {
                const data = res.data?.data?.map((item: any) => ({
                    id: '',
                    userId: item?.userId,
                    endSafeSerial: item?.serialCode,
                    safeMake: item?.make?.name,
                    safeModel: item?.model?.name,
                    safeType: item?.safeType?.name,
                }))
                dispatch({
                    type: ReportActionTypes.GET_USER_SAFE_STORAGES,
                    payload: data,
                })
            })
            .catch((errors) => {
                // dispatch({
                //     type: EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL,
                //     payload: false,
                // })
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const getAccessories = (id: string) => {
    return (dispatch: Redux.Dispatch) => {
        const params = {
            limit: 0,
        }
        const url = `${APIServices.apiUrlV1}/admin/users/${id}/accessories`
        // APIServices.axiosConfig()
        axios
            .get(`${url}`, { params })
            .then((res) => {
                const data = res.data?.data?.map((item: any) => ({
                    id: item?.code,
                    image: item?.imageUrl,
                    ffl: item?.fflId,
                    make: item?.make?.name,
                    model: item?.model?.name,
                    caliber: item?.caliber,
                }))
                dispatch({
                    type: ReportActionTypes.GET_USER_ACCESSORIES,
                    payload: data,
                })
            })
            .catch((errors) => {
                // dispatch({
                //     type: EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL,
                //     payload: false,
                // })
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const getParts = (id: string) => {
    return (dispatch: Redux.Dispatch) => {
        const params = {
            limit: 0,
        }
        const url = `${APIServices.apiUrlV1}/admin/users/${id}/parts`
        // APIServices.axiosConfig()
        axios
            .get(`${url}`, { params })
            .then((res) => {
                const data = res.data?.data?.map((item: any) => ({
                    id: item?.code,
                    image: item?.imageUrl,
                    ffl: item?.fflId,
                    component: item?.component,
                    serial: item?.serialCode,
                }))
                dispatch({
                    type: ReportActionTypes.GET_USER_PARTS,
                    payload: data,
                })
            })
            .catch((errors) => {
                // dispatch({
                //     type: EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL,
                //     payload: false,
                // })
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const getAmmunitions = (id: string) => {
    return (dispatch: Redux.Dispatch) => {
        const params = {
            limit: 0,
        }
        const url = `${APIServices.apiUrlV1}/admin/users/${id}/ammunition`
        // APIServices.axiosConfig()
        axios
            .get(`${url}`, { params })
            .then((res) => {
                const data = res.data?.data?.map((item: any) => ({
                    id: item?.code,
                    image: item?.imageUrl,
                    ffl: item?.fflId,
                    make: item?.make?.name,
                    qty: Number(item?.qty),
                    DatePurchase: item?.madeAt
                        ? moment(item?.madeAt).format('DD/MM/YYYY')
                        : '',
                    qmicrostamp: item?.qmicrostamp,
                    caliber: item?.caliber,
                }))
                dispatch({
                    type: ReportActionTypes.GET_USER_AMMUNITIONS,
                    payload: data,
                })
            })
            .catch((errors) => {
                // dispatch({
                //     type: EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL,
                //     payload: false,
                // })
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const getInvoices = (id: string) => {
    return (dispatch: Redux.Dispatch) => {
        const params = {
            limit: 0,
        }
        const url = `${APIServices.apiUrlV1}/admin/users/${id}/invoices`
        // APIServices.axiosConfig()
        axios
            .get(`${url}`, { params })
            .then((res) => {
                const data = res.data?.data?.map((item: any) => ({
                    id: item?.code,
                    qty: Number(item?.totalQty) || 0,
                    subTotalAmount: item?.subTotalAmount
                        ? Number(item?.subTotalAmount).toFixed(2)
                        : '0.00',
                    totalAmount: item?.totalAmount
                        ? Number(item?.totalAmount).toFixed(2)
                        : '0.00',
                    totalDiscountAmount: item?.totalDiscountAmount
                        ? Number(item?.totalDiscountAmount).toFixed(2)
                        : '0.00',
                }))
                dispatch({
                    type: ReportActionTypes.GET_USER_INVOICES,
                    payload: data,
                })
            })
            .catch((errors) => {
                // dispatch({
                //     type: EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL,
                //     payload: false,
                // })
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const setUserLoading = (payload: boolean) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({
            type: ReportActionTypes.SET_USER_LOADING,
            payload,
        })
    }
}

const getUsers = () => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        dispatch(setUserLoading(true) as any)

        const params = getState()?.report?.users?.userQueries
        // APIServices.axiosConfig()
        axios
            .get(users, { params })
            .then((res: AxiosResponse) => {
                dispatch(setUserLoading(false) as any)
                const data = res?.data?.data?.map(
                    (user: MReportUser) => new MReportUser(user)
                )
                const userMetadata = res?.data?.metadata
                const payload = { users: data, userMetadata }
                dispatch({ type: ReportActionTypes.GET_USERS, payload })
            })
            .catch((errors: AxiosError) => {
                dispatch(setUserLoading(false) as any)
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const setUsersQueries = (params?: ICommonQuery) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        const currentQueries = getState()?.report?.users?.userQueries
        const payload = { ...currentQueries, ...params }
        dispatch({ type: ReportActionTypes.SET_USER_QUERIES, payload })
    }
}

const UserReportActions = {
    getUserDetail,
    getFirearms,
    getInsurances,
    getInspections,
    getSafeStorages,
    getAccessories,
    getParts,
    getAmmunitions,
    getInvoices,
    getUsers,
    setUsersQueries,
    setUserLoading,
}
export default UserReportActions
